import { Injectable } from '@angular/core';

import { RepositoryService } from '@_services/api/repository.service';
import { GeneratedOrganizationLeadTodoApiService } from './organization-lead-todo-api-generated.service';

@Injectable({
  providedIn: 'root'
})
export class OrganizationLeadTodoApiService extends GeneratedOrganizationLeadTodoApiService {
  constructor(repo: RepositoryService) {
    super(repo);
  }
}
